import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaTags, FaTicketAlt, FaBarcode } from 'react-icons/fa';
import ModuleLayout from '../../layout/ModuleLayout';
import PromotionListPage from '../Promotion/PromotionListPage';
import LabelGenerationPage from '../Promotion/LabelGenerationPage';

const PromotionModule = () => {
  const { t } = useTranslation();

  const moduleConfig = {
    id: 'promotion',
    title: t('modules.promotion.title'),
    description: t('modules.promotion.description'),
    icon: FaTags,
    color: '#d63384',
    menuItems: [
      {
        path: '/promotion-module/list',
        icon: FaTicketAlt,
        label: t('nav.promotions')
      },
      {
        path: '/promotion-module/labels',
        icon: FaBarcode,
        label: 'Génération tickets'
      }
    ]
  };

  return (
    <ModuleLayout moduleConfig={moduleConfig}>
      <Routes>
        <Route path="/" element={<Navigate to="/promotion-module/list" replace />} />
        <Route path="/list" element={<PromotionListPage />} />
        <Route path="/labels" element={<LabelGenerationPage />} />
      </Routes>
    </ModuleLayout>
  );
};

export default PromotionModule;
